// extracted by mini-css-extract-plugin
export default {"form":"EditarUsuario_form__Kfhet","areaBtn":"EditarUsuario_areaBtn__irsMB","btn":"EditarUsuario_btn__5kdBK"};